<template>
  <div>
    <div
      class="link-facility-desc-wrapper mb-10"
      v-loading="getLinkedSiteLoading"
      v-if="p('Organisations.Edit') || p('Organisations.Network.Edit')"
    >
      <div v-if="linkedSite">
        {{ $t('text.your_organization_is_already_linked_site') }}
        {{ linkedSite.Name }} ({{ $t('text.installation_id') }}:
        <b>{{ linkedSite.InstallationId }}</b
        >). {{ $t('text.you_can') }}
        <b
          class="underline important-text pointer blue-font"
          @click="linkAnotherFacility"
          >{{ $t('text.add_a_different_installation_id') }}</b
        >
        {{ $t('text.or') }}
        <b
          class="underline important-text pointer light-red-font"
          @click="unLinkFacility"
          >{{ $t('text.remove_this_installation_id') }}</b
        >.
      </div>
      <div v-else>
        {{ $t('text.your_organization_is_not_link_organisation') }}
        <b
          class="underline important-text pointer blue-font"
          @click="linkFacility"
          >{{ $t('text.register_an_installation_id') }}</b
        >.
      </div>
      <div class="light-font mt-5">
        {{ $t('text.add_installation_id_desc') }}
      </div>
    </div>
    <div
      class="link-facility-desc-wrapper mb-10"
      v-loading="getLinkedLoRaNetworkLoading"
      v-if="p('Organisations.Edit') || p('Organisations.Network.Edit')"
    >
      <div v-if="linkedLoRaNetwork">
        {{ $t('text.your_organization_is_already_linked_lora_network') }}
        ({{ $t('text.application_id') }}: <b>{{ linkedLoRaNetwork }}</b
        >). {{ $t('text.you_can') }}
        <b
          class="underline important-text pointer blue-font"
          @click="linkAnotherLoRaNetwork"
          >{{ $t('text.add_a_different_lora_network') }}</b
        >
        {{ $t('text.or') }}
        <b
          class="underline important-text pointer light-red-font"
          @click="unLinkLoRaNetwork"
          >{{ $t('text.remove_this_lora_network') }}</b
        >.
      </div>
      <div v-else>
        {{ $t('text.your_organization_is_not_link_lora_network') }}
        <b
          class="underline important-text pointer blue-font"
          @click="linkLoRaNetwork"
          >{{ $t('text.add_a_lora_network') }}</b
        >.
      </div>
      <div class="light-font mt-5">
        {{ $t('text.add_lora_network_desc') }}
      </div>
    </div>
    <div class="page-card-wrapper">
      <div class="page-card-title">
        <span class="page-card-title-text"
          >BLE - IoT {{ $t('text.network_map') }}</span
        >
      </div>
      <div class="page-card-content">
        <div class="text-right mt-10">
          <el-checkbox v-model="zoomView">{{
            $t('text.zoom_in_chart')
          }}</el-checkbox>
        </div>
        <div v-if="loading" class="loading-chart-wrapper">
          <LoadingAnimation />
        </div>
        <div v-else>
          <el-row :gutter="20" class="network-maps-row">
            <!-- Left side: Wi-Fi/LAN Network -->
            <el-col
              :xs="24"
              :sm="24"
              :md="this.hasLoraDevices ? 12 : 24"
              :lg="this.hasLoraDevices ? 12 : 24"
              v-if="this.hasWifiDevices || !this.hasLoraDevices"
            >
              <div class="network-section">
                <div class="network-section-title">
                  {{ $t('text.wifi_infrastructure') }} / LAN
                </div>
                <div
                  id="network-map-wifi"
                  v-if="wifiNodes.length"
                  class="network-map-wrapper"
                ></div>
                <div v-else class="no-data min-h-300 v-h-center wp-100">
                  <b>{{ $t('text.no_nodes') }}</b>
                </div>
              </div>
            </el-col>
            <!-- Right side: LoRa Network -->
            <el-col
              :xs="24"
              :sm="24"
              :md="this.hasWifiDevices ? 12 : 24"
              :lg="this.hasWifiDevices ? 12 : 24"
              v-if="this.hasLoraDevices || !this.hasWifiDevices"
            >
              <div class="network-section">
                <div class="network-section-title">
                  LoRa {{ $t('text.network_map') }}
                </div>
                <div
                  id="network-map-lora"
                  v-if="loraNodes.length"
                  class="network-map-wrapper"
                ></div>
                <div v-else class="no-data min-h-300 v-h-center wp-100">
                  <b>{{ $t('text.no_nodes') }}</b>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <LinkFacility
        ref="linkFacility"
        @success="
          getLinkedSite()
          getData()
        "
      />
      <LinkLoRaNetwork
        ref="linkLoRaNetwork"
        @success="
          getLinkedLoRaNetwork()
          getData()
        "
      />
    </div>
  </div>
</template>

<script>
import { DataSet, Network } from 'vis-network/standalone'
import ApiService from '@/services/ApiService.js'
import moment from 'moment'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
import LinkFacility from '@/components/manage/organisation/LinkFacility.vue'
import LinkLoRaNetwork from '@/components/manage/organisation/LinkLoRaNetwork.vue'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
  data() {
    return {
      zoomView: false,
      loading: false,
      nodes: [],
      edges: [],
      wifiNodes: [],
      wifiEdges: [],
      loraNodes: [],
      loraEdges: [],
      wifiChart: null,
      loraChart: null,
      hasWifiDevices: false,
      hasLoraDevices: false,
      timer: null,
      linkedSite: null,
      getLinkedSiteLoading: false,
      linkedLoRaNetwork: null,
      getLinkedLoRaNetworkLoading: false,
      latestVersion: null
    }
  },
  components: {
    LoadingAnimation,
    LinkFacility,
    LinkLoRaNetwork
  },
  mounted() {
    this.getLinkedSite()
    this.getLinkedLoRaNetwork()
    this.loading = true
    this.getLatestVersion().then(() => {
      this.loading = false
      this.getData()
    })
    this.timer = setInterval(this.getData, 180000)
  },
  watch: {
    zoomView() {
      if (this.hasWifiDevices) {
        this.initWifiChart()
      }
      if (this.hasLoraDevices) {
        this.initLoraChart()
      }
    },
    '$store.state.locale.currentLocale': function() {
      this.getData()
    },
    '$store.state.filter.dashboardFilter': {
      handler: _.debounce(function() {
        this.getData()
      }, 100),
      deep: true
    }
  },
  methods: {
    async getLatestVersion() {
      await ApiService.GetFwVerV2('node').then(response => {
        if (response.data.success) {
          this.latestVersion = response.data.data.version
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    getLinkedSite() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.getLinkedSiteLoading = true
      ApiService.GetLinkedSite(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(res => {
          this.getLinkedSiteLoading = false
          if (res.data.data && res.data.data.length) {
            this.linkedSite = res.data.data[0]
          } else {
            this.linkedSite = null
          }
        })
        .catch(() => {
          this.getLinkedSiteLoading = false
          this.linkedSite = null
        })
    },
    getLinkedLoRaNetwork() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.getLinkedLoRaNetworkLoading = true
      ApiService.GetLinkedLoRaNetwork(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(res => {
          this.getLinkedLoRaNetworkLoading = false
          if (res.data.data) {
            this.linkedLoRaNetwork = res.data.data
          } else {
            this.linkedLoRaNetwork = null
          }
        })
        .catch(() => {
          this.getLinkedLoRaNetworkLoading = false
          this.linkedLoRaNetwork = null
        })
    },
    linkFacility() {
      this.$refs.linkFacility.openDialog()
    },
    linkAnotherFacility() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.link_another_installation_id_warning'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.continue').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.linkFacility()
        })
        .catch(() => {})
    },
    unLinkFacility() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.remove_installation_id_warning'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.remove').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleUnlink()
        })
        .catch(() => {})
    },
    handleUnlink() {
      this.loading = true
      ApiService.UnLinkFacility(
        this.$store.getters[`user/selecteOrganisationId`],
        this.linkedSite.SiteId
      )
        .then(res => {
          this.loading = false
          if (res.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.remove_successful')
            })
            this.getLinkedSite()
            this.getData()
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: res.data.msg + '.'
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    linkLoRaNetwork() {
      this.$refs.linkLoRaNetwork.openDialog()
    },
    linkAnotherLoRaNetwork() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.link_another_lora_network_warning'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.continue').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.linkLoRaNetwork()
        })
        .catch(() => {})
    },
    unLinkLoRaNetwork() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.remove_lora_network_warning'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.remove').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleUnlinkLoRa()
        })
        .catch(() => {})
    },
    handleUnlinkLoRa() {
      this.loading = true
      ApiService.UnLinkLoRaNetwork(
        this.$store.getters[`user/selecteOrganisationId`],
        this.linkedLoRaNetwork
      )
        .then(res => {
          this.loading = false
          if (res.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.remove_successful')
            })
            this.getLinkedLoRaNetwork()
            this.getData()
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: res.data.msg + '.'
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getData() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.loading = true
      if (this.wifiChart) {
        this.wifiChart.destroy()
      }
      if (this.loraChart) {
        this.loraChart.destroy()
      }
      this.nodes = this.edges = this.wifiNodes = this.wifiEdges = this.loraNodes = this.loraEdges = []
      this.hasWifiDevices = false
      this.hasLoraDevices = false
      this.getSiteNodes().then(() => {
        this.loading = false
        if (this.hasWifiDevices || this.hasLoraDevices) {
          this.$nextTick(() => {
            if (this.hasWifiDevices) {
              this.initWifiChart()
            }
            if (this.hasLoraDevices) {
              this.initLoraChart()
            }
          })
        }
      })
    },
    async getSiteNodes() {
      await ApiService.getSiteNodes(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        if (response.data.success) {
          let allNodes = response.data.data

          // Separate nodes by device type
          let wifiDevices = allNodes.filter(
            item => item.DeviceType === 'BLE_IOT'
          )
          let loraGateways = allNodes.filter(
            item => item.DeviceType === 'BLE_LORA_GATEWAY'
          )
          let loraDevices = allNodes.filter(
            item => item.DeviceType === 'BLE_LORA'
          )

          // Track if we have actual devices (not just LAN)
          this.hasWifiDevices = wifiDevices.length > 0
          this.hasLoraDevices =
            loraGateways.length > 0 || loraDevices.length > 0

          // Process Wi-Fi/LAN Network
          this.wifiNodes = wifiDevices.map(item => this.createNodeObject(item))
          let wifi = {
            id: 1,
            label: `<b>${this.$t('text.wifi_infrastructure')}</b>`,
            image: require('@/assets/image/network-img/wifi.png')
          }
          let wifiLan = {
            id: 2,
            size: 12,
            label: `<b>${this.$t('text.lan')}</b>`,
            image: require('@/assets/image/network-img/lan.png')
          }
          this.wifiNodes.unshift(wifi)
          this.wifiNodes.unshift(wifiLan)

          // Create Wi-Fi edges
          wifiDevices.forEach(item => {
            if (item.ParentMac && item.ParentMac.trim()) {
              // Connected to another node
              let edgeItem = {
                from: item.ParentMac,
                to: item.MacAddress,
                dashes: false
              }
              this.wifiEdges.push(edgeItem)
            } else {
              // Root node without parent - connect to LAN
              let edgeItem = {
                from: 2,
                to: item.MacAddress,
                dashes: false
              }
              this.wifiEdges.push(edgeItem)
            }
          })

          // Process LoRa Network
          let loraAllDevices = [...loraGateways, ...loraDevices]
          this.loraNodes = loraAllDevices.map(item =>
            this.createNodeObject(item)
          )

          // Add LAN node for LoRa network
          let loraLan = {
            id: 3,
            size: 12,
            label: `<b>${this.$t('text.lan')}</b>`,
            image: require('@/assets/image/network-img/lan.png')
          }
          this.loraNodes.unshift(loraLan)

          // Connect LoRa gateways to LAN
          loraGateways.forEach(gateway => {
            let edgeItem = {
              from: 3,
              to: gateway.MacAddress,
              dashes: false
            }
            this.loraEdges.push(edgeItem)
          })
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    createNodeObject(item) {
      let version =
        item.FirmwareVersion && item.FirmwareVersion.trim()
          ? item.FirmwareVersion.replace(/^Node-/i, '')
          : null

      // Build location string
      let locationParts = []
      if (item.BuildingName && item.BuildingName.trim()) {
        locationParts.push(item.BuildingName)
      }
      if (item.FloorName && item.FloorName.trim()) {
        locationParts.push(item.FloorName)
      }
      if (item.RoomNumber && item.RoomNumber.trim()) {
        locationParts.push(item.RoomNumber)
      }
      let locationStr =
        locationParts.length > 0 ? locationParts.join(',') : 'N/A'

      // Format LastSeen time
      let lastSeenStr = ''
      if (item.LastSeen) {
        let lastSeenTime = moment(item.LastSeen)
        lastSeenStr = lastSeenTime.isValid() ? lastSeenTime.fromNow() : ''
      }

      return {
        id: item.MacAddress,
        isOnline: item.IsOnline,
        image: this.getNodeIcon(item),
        label: `<b>${locationStr}</b> ${version ? '(' + version + ')' : ''}\n${
          item.MacAddress
        }\n${lastSeenStr ? 'Last Seen: ' + lastSeenStr : ''}`,
        font: {
          color:
            item.IsOnline &&
            (!version ||
              !this.latestVersion ||
              this.latestVersion.toLowerCase() === version.toLowerCase())
              ? 'black'
              : item.IsOnline
              ? 'black'
              : 'red',
          multi: 'html'
        }
      }
    },
    getNodeIcon(item) {
      // Select icon based on DeviceType and IsOnline status
      const isBLELora = item.DeviceType === 'BLE_LORA'
      const isBLELoraGateway = item.DeviceType === 'BLE_LORA_GATEWAY'
      const isOnline = item.IsOnline

      if (isBLELoraGateway) {
        // Use gateway icon for LoRa gateways
        return isOnline
          ? require('@/assets/image/network-img/gateway.png')
          : require('@/assets/image/network-img/gateway-red.png')
      } else if (isBLELora) {
        // Use LoRa icon for LoRa nodes
        return isOnline
          ? require('@/assets/image/network-img/lora.png')
          : require('@/assets/image/network-img/lora-red.png')
      } else {
        // Use room icon for IoT nodes (BLE_IOT)
        return isOnline
          ? require('@/assets/image/network-img/room.png')
          : require('@/assets/image/network-img/room-red.png')
      }
    },
    initWifiChart() {
      let container = document.getElementById('network-map-wifi')
      if (!container || !this.hasWifiDevices) return

      let options = {
        width: '100%',
        height: '100%',
        layout: {
          randomSeed: 1
        },
        interaction: {
          zoomView: this.zoomView,
          hover: true,
          tooltipDelay: 0
        },
        nodes: {
          font: {
            multi: 'html',
            size: 11,
            vadjust: -5
          }
        },
        edges: {
          length: 250,
          font: {
            multi: 'html',
            size: 11
          }
        }
      }

      let connectEdge = this.wifiEdges.filter(item => {
        return item.from && item.to
      })
      if (!connectEdge.length) {
        options.layout.hierarchical = {
          levelSeparation: 195,
          nodeSpacing: 200,
          treeSpacing: 200,
          direction: 'UD',
          sortMethod: 'directed'
        }
      }
      let nodes = new DataSet(this.wifiNodes)
      let edges = new DataSet(this.wifiEdges)
      let data = {
        nodes: nodes.map(item => {
          return {
            ...item,
            shape: 'image'
          }
        }),
        edges: edges
      }
      this.wifiChart = new Network(container, data, options)
    },
    initLoraChart() {
      let container = document.getElementById('network-map-lora')
      if (!container || !this.hasLoraDevices) return

      let options = {
        width: '100%',
        height: '100%',
        layout: {
          randomSeed: 1
        },
        interaction: {
          zoomView: this.zoomView,
          hover: true,
          tooltipDelay: 0
        },
        nodes: {
          font: {
            multi: 'html',
            size: 11,
            vadjust: -5
          }
        },
        edges: {
          length: 200,
          font: {
            multi: 'html',
            size: 11
          }
        }
      }

      let nodes = new DataSet(this.loraNodes)
      let edges = new DataSet(this.loraEdges)

      // Set fixed positions for circular layout
      let nodesMap = nodes.map(item => {
        if (item.id === 3) {
          // LAN in center
          return {
            ...item,
            shape: 'image',
            x: 0,
            y: 0,
            fixed: true
          }
        }
        return {
          ...item,
          shape: 'image'
        }
      })

      // Calculate circular positions for gateways and devices
      let gateways = this.loraNodes
        .filter(
          n => n.id !== 3 && this.wifiNodes.some(w => w.id === n.id) === false
        )
        .filter(n => {
          // Check if this is a gateway (BLE_LORA_GATEWAY)
          return this.loraEdges.some(e => e.from === 3 && e.to === n.id)
        })
      let devices = this.loraNodes.filter(
        n => n.id !== 3 && !gateways.some(g => g.id === n.id)
      )

      // Position gateways in first circle (radius 200)
      gateways.forEach((gateway, idx) => {
        let angle = (idx / gateways.length) * 2 * Math.PI
        let node = nodesMap.find(n => n.id === gateway.id)
        if (node) {
          node.x = Math.cos(angle) * 200
          node.y = Math.sin(angle) * 200
          node.fixed = true
        }
      })

      // Position devices in second circle (radius 350)
      devices.forEach((device, idx) => {
        let angle = (idx / devices.length) * 2 * Math.PI
        let node = nodesMap.find(n => n.id === device.id)
        if (node) {
          node.x = Math.cos(angle) * 350
          node.y = Math.sin(angle) * 350
          node.fixed = true
        }
      })

      let data = {
        nodes: new DataSet(nodesMap),
        edges: edges
      }
      this.loraChart = new Network(container, data, options)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    if (this.wifiChart) {
      this.wifiChart.destroy()
    }
    if (this.loraChart) {
      this.loraChart.destroy()
    }
  }
}
</script>

<style scoped>
.network-section {
  display: flex;
  flex-direction: column;
  height: 600px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fafafa;
}

.network-section-title {
  padding: 12px 16px;
  background-color: #f0f1f2;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}

.network-map-wrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.loading-chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 600px;
}
</style>
